export default {
	custom : {
		email : {
			required: 'Il campo e-mail è obbligatorio',
			email: 'È necessario inserire un indirizzo e-mail valido'
		},
		telefono : {
			required: 'Il campo telefono è obbligatorio',
			length: 'Il campo telefono è compilato in modo errato'
		},
		nombre : {
			required: 'Il campo nome è obbligatorio'
		},
		name: {
			required: 'Il campo nome e cognome è obbligatorio'
		},
		
		job_title: {
			required: 'Il campo titolo del lavoro è obbligatorio'
		},
		company: {
			required: 'Il campo azienda è obbligatorio'
		},
		mensaje : {
			required: 'Il campo messaggio è obbligatorio'
		},
		apellidos : {
			required: 'Il campo cognome è obbligatorio'
		},
		politica : {
			required: "È necessario accettare l'informativa sulla privacy"
		},
		acceptance_privacy: {
			required: "È necessario accettare l'informativa sulla privacy"
		},
		
		direccion : {
			required: 'Il campo indirizzo è obbligatorio'
		},
		pais : {
			required: 'Il campo Paese è obbligatorio'
		},
		carta_presentacion : {
			required: 'Il campo lettera di presentazione è obbligatorio'
		},
		doc_adjunto : {
			size: 'La dimensione massima è di 2MB',
			mimes: 'Il formato deve essere PDF'
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/it.js